import { Button, Space, Descriptions } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

import { getDetail2 } from '@/api/recall';
import { useRequest } from 'ahooks';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { PublishStatusMap, UserEnum, JumpTypeMap, JumpTypeEnum } from './type';
import { getPushMessageRecordDetail } from '@/api/noticeConfig';

const RecallEmailDetail = () => {
  const { id } = useParams();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, run } = useRequest(
    (id) => getPushMessageRecordDetail({ id }),
    {
      manual: true,
    }
  );

  const detail = useMemo(() => {
    if (!data) return;
    return data.data.data;
  }, [data]);

  console.log(detail, "default")

  useEffect(() => {
    if (!id) return;
    run(id);
  }, [id]);

  const navigator = useNavigate();

  function onCancel() {
    navigator(-1);
  }

  return (
    <div>
      <Descriptions>
        <Descriptions.Item label="推送对象" span={24}>
          {detail && UserEnum[detail.pushTargetType]}
        </Descriptions.Item>
        <Descriptions.Item label="推送标题（英）" span={24}>
          {detail?.pushTitle}
        </Descriptions.Item>
        <Descriptions.Item label="推送标题（日）" span={24}>
          {detail?.pushTitleJa}
        </Descriptions.Item>
        <Descriptions.Item label="正文（英）" span={24}>
          <div
            dangerouslySetInnerHTML={{ __html: detail?.pushContent ?? '' }}
          ></div>
        </Descriptions.Item>
        <Descriptions.Item label="正文（日）" span={24}>
          <div
            dangerouslySetInnerHTML={{ __html: detail?.pushContentJa ?? '' }}
          ></div>
        </Descriptions.Item>
        <Descriptions.Item label="推送时间（日本时间）" span={24}>
          {detail?.pushTime && dayjs(detail?.pushTime).format("YYYY-MM-DD HH:mm")}
        </Descriptions.Item>
        <Descriptions.Item label="推送状态" span={24}>
          {detail && PublishStatusMap.get(detail.pushStatus)}
        </Descriptions.Item>
        <Descriptions.Item label="跳转链接" span={24}>
          {detail?.jumpType !== undefined && detail?.jumpType !== null
            ? JumpTypeMap.get(detail.jumpType) || `未知(${detail.jumpType})`
            : '无跳转'}
        </Descriptions.Item>
        {detail?.jumpType === JumpTypeEnum.ARTWORK_DETAIL && (
          <Descriptions.Item label="作品ID" span={24}>
            {detail?.artworkId ?? '-'}
          </Descriptions.Item>
        )}
        {detail?.jumpType === JumpTypeEnum.CHALLENGE_DETAIL && (
          <Descriptions.Item label="挑战赛ID" span={24}>
            {detail?.bizId ?? '-'}
          </Descriptions.Item>
        )}
        {/* <Descriptions.Item label="操作人员" span={24}>
          {detail?.upd}
        </Descriptions.Item> */}
      </Descriptions>
      <Space style={{ width: '100%', justifyContent: 'center' }}>
        <Button onClick={onCancel}>返回</Button>
      </Space>
    </div>
  );
};

export default RecallEmailDetail;
